import React, { useState } from 'react';

const StepThree = ({ form, onChange, onNext, onPrev }) => {
  const [error, setError] = React.useState('');
  const [showPassword, setShowPassword] = useState(false); 

  const validatePassword = (password) => {
    if (password.length < 8 || password.length > 30) {
      return 'رمز عبور باید بین ۸ تا ۳۰ کاراکتر باشد';
    }
    if (!/[A-Z]/.test(password)) {
      return 'رمز عبور باید حداقل یک حرف بزرگ انگلیسی داشته باشد';
    }
    if (!/[a-z]/.test(password)) {
      return 'رمز عبور باید حداقل یک حرف کوچک انگلیسی داشته باشد';
    }
    if (!/[0-9]/.test(password)) {
      return 'رمز عبور باید حداقل یک عدد داشته باشد';
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return 'رمز عبور باید حداقل یک سیمبل (نماد) مانند @، #، $ و غیره داشته باشد';
    }
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const passwordError = validatePassword(form.password);

    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError('رمز عبور و تکرار آن یکسان نیستند');
      return;
    }

    setError('');
    onNext();
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
        {error && <div className='error-message'>{error}</div>}
      <div className='input-group'>
        <label>رمز عبور</label>
        <input
          
            type={showPassword ? "text" : "password"}
            name="password"
            value={form.password}
            onChange={onChange}
            required
           
            placeholder="مثال: Aa12345@ (شامل حروف بزرگ، کوچک، عدد و نماد)"
        />
      </div>

      <div className='input-group'>
        <label>تکرار رمز عبور</label>
        <input
            type={showPassword ? "text" : "password"}
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={onChange}
            required
            placeholder="رمز عبور خود را دوباره وارد کنید"
        />
      </div>

      <div className='input-group' style={{ marginTop: '0.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', direction: 'rtl' }}>
        <input
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
            style={{ width: 'auto', marginLeft: '0.5rem' }}
        />
        <label htmlFor="showPassword" style={{ fontWeight: 'normal', fontSize: '0.875rem', marginRight: '0.25rem' }}>نمایش رمز عبور</label>
      </div>

      <div className="form-actions">
        <button type="button" className="back-btn" onClick={onPrev}>
          قبلی
        </button>
        <button type="submit" className="next-btn">
          مرحله بعد
        </button>
      </div>
    </form>
  );
};

export default StepThree;